import { ButtonProps, Stack, styled } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';

export const Wrapper = styled(Stack)`
  border-radius: 4px;
  background: var(--dk-bg, #fff);
  border: 1px solid var(--dk-line-strong, #d4d7db);

  &.mobile-style {
    .CommentEditor .editor-scroller {
      max-height: 50px;
    }
  }

  &.top-style {
  }

  &.fixed-style {
  }

  &.focus {
    border: 1px solid #000;

    .footer {
      border-top: 1px solid #000;
    }

    .CommentEditor .editor-scroller {
      max-height: initial;
    }
  }
`;

export const Footer = styled(Stack)`
  padding: 8px;
  align-items: center;
  gap: 12px;
  border-top: 1px solid var(--dk-line-strong, #d4d7db);
`;

export const UtilButton = styled(({ children, ...props }: ButtonProps) => (
  <Button {...props} disableRipple>
    {children}
  </Button>
))(() => ({
  width: '24px',
  height: '24px',
  padding: '2px',
  margin: 0,
}));

const FormButton = styled(Button)`
  padding: 8px 12px;
  min-width: 64px;
  height: 36px;

  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(FormButton)`
  color: var(--dk-danger, #f55060);
  background: var(--dk-bg, #fff);

  :hover {
    color: var(--dk-danger, #f55060);
    background: var(--dk-bg-muted, #f3f5f6);
  }
`;
export const SubmitButton = styled(FormButton)`
  background: #06c;
  color: #fff;

  :hover {
    background: #06c;
    color: #fff;
  }

  &:disabled {
    background: rgba(0, 102, 204, 0.2);
    color: #fff;
  }
`;

export const FormButtonWrapper = styled(Stack)`
  margin-left: auto;
  height: 36px;
`;
